module.exports = __webpack_public_path__ + "static/media/blog-41-2.8fe0f0d0.webp";